export default __webpack_public_path__ + "static/beauti-8fbbdde6b7cc0d1195ae39213bcfb191.png";